import { createFileRoute } from '@tanstack/react-router'

import { SectionsListView, sectionListFiltersSchema } from '@/modules/sections'

export const Route = createFileRoute('/_auth/sections/list')({
  component: SectionsListView,
  validateSearch: sectionListFiltersSchema
})
